import React from 'react';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { Select } from '@bringg/react-components';
import useStore from '../../stores/helpers/use-context';
import useDateFormat from '../../hooks/use-date-format';
import './main-details.scss';
import { findEarliestTaskTime } from '../../utils/date-utils';

const RoutesPlannerMainDetails: React.FC = () => {
	const {
		team,
		sortedTasksDates,
		presentedDate,
		setPresentedDate,
		translations,
		initRunsToDisplay,
		ganttStore,
		resetPreviousUserChange,
		updateTasksById,
		tasksByDate
	} = useStore();

	const dateFormat = useDateFormat();
	const presentedDateFormat = `dd - ${dateFormat}`;

	const onDateChange = date => {
		setPresentedDate(moment(date));
		updateTasksById();
		initRunsToDisplay();
		const firstTaskTime = findEarliestTaskTime(Array.from(tasksByDate.get(date).values())).tz(team?.time_zone);
		ganttStore.ganttApi?.api.moveTo(firstTaskTime.toISOString());
		resetPreviousUserChange();
	};

	const datesOptions = sortedTasksDates
		.filter(date => moment(date).isValid())
		.map(date => ({
			id: date.toISOString(),
			name: date.utc().format(presentedDateFormat)
		}));

	return (
		<div className="main-details">
			{datesOptions.length ? (
				<>
					<div className="main-details-team-name">{team.name}</div>
					<>
						{datesOptions.length === 1 ? (
							<span data-test-id="main-details-date">
								{presentedDate?.tz(team.time_zone).format(presentedDateFormat)}
							</span>
						) : (
							<div className="main-detail-select">
								<Select
									options={datesOptions}
									value={presentedDate.toISOString()}
									onChange={onDateChange}
									data-test-id="presented-date-select"
									popupClassName="presented-date-select"
								/>
							</div>
						)}
					</>
				</>
			) : (
				<div className="main-details-team-name">
					{translations.routesTableTranslations.headers.routesPlanner}
				</div>
			)}
		</div>
	);
};

export default observer(RoutesPlannerMainDetails);
